"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3617],{

/***/ 3617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CityDT; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _utils_CommonUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4250);
/* eslint-disable react/no-danger */ 


function CityDT(props) {
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.body.classList.add("bodyClass");
        document.body.id = "cmsintlflt";
        document.body.setAttribute("data-domain", "www_intl_flight_makemytrip_com");
    });
    var ref = (props === null || props === void 0 ? void 0 : props.data) || {}, blocksData = ref.blocksData, content = ref.content;
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var middleBlockHtml = "".concat((blocksData === null || blocksData === void 0 ? void 0 : blocksData.contentTop) ? blocksData.contentTop : "").concat((blocksData === null || blocksData === void 0 ? void 0 : blocksData.contentMiddle) ? blocksData.contentMiddle : "").concat(content ? content : "").concat((blocksData === null || blocksData === void 0 ? void 0 : blocksData.contentBottom) ? blocksData.contentBottom : "").concat((blocksData === null || blocksData === void 0 ? void 0 : blocksData.bottomBlock) ? blocksData.bottomBlock : "");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        var buttons = (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll(".ViewFareBtn");
        if (buttons) {
            buttons === null || buttons === void 0 ? void 0 : buttons.forEach(function(button) {
                var url = button.getAttribute("data-url");
                if (url) {
                    button.onclick = function() {
                        return window.location.replace(url);
                    };
                }
            });
        }
    }, [
        middleBlockHtml
    ]);
    // Before passing, make sure the string has data-url instead of onclick
    var sanitizedHtml = middleBlockHtml.replace(/onclick="[^"]*"/, "");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "fli-intl-container prepend_top20 clearfix listingContainer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "makeCenterCol clearfix noPadding",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            id: "seoContentMiddle",
                            className: "seoOnlyBlock col-lg-9 col-md-12 col-sm-12 col-xs-12 paddL0 airline-left-container nopadding-mob paddR0 ",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                ref: containerRef,
                                children: (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_2__/* .transformToHtml */ .cR)(sanitizedHtml)
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            id: "seoRightBlock",
                            className: "seoOnlyBlock col-lg-3 col-md-12 col-sm-12 col-xs-12 airline-right-container nopadding-mob paddR0 ",
                            children: [
                                (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_2__/* .transformToHtml */ .cR)(blocksData === null || blocksData === void 0 ? void 0 : blocksData.filterBlock),
                                (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_2__/* .transformToHtml */ .cR)(blocksData === null || blocksData === void 0 ? void 0 : blocksData.rightBlock),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    dangerouslySetInnerHTML: {
                                        __html: blocksData === null || blocksData === void 0 ? void 0 : blocksData.leftBlock
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: blocksData === null || blocksData === void 0 ? void 0 : blocksData.top_overlay
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "seo-bottom",
                className: "seo",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    name: "domain_id",
                    id: "domain_id",
                    type: "hidden",
                    value: "www_intl_flight_makemytrip_com"
                })
            })
        ]
    });
}


/***/ })

}]);